import {HTMLAttributes} from 'react';
import {twMerge} from '../../../common/twMerge';
import {Text} from '../../atoms/Text/Text';

interface DialogLabelProps extends HTMLAttributes<HTMLDivElement> {}

export function DialogLabel({children, className, ...props}: DialogLabelProps) {
  return (
    <div
      className={twMerge(
        'font-medium2 whitespace-pre-wrap break-all text-center text-theme-solid-100',
        className
      )}
      {...props}
    >
      <Text>{children}</Text>
    </div>
  );
}

export const DialogLabelType = (<DialogLabel />).type;
